import { MeInformationService } from '@api'
import type { AxiosError } from 'axios'
import { useQuery } from 'react-query'

import { useToast } from '@/components/ui/toast'

import { useAccount } from '../hooks/useAccounts'

export const LogoutHandler = () => {
  const toast = useToast()
  const { logout, isLoggedIn, checkedAuthentication } = useAccount()

  useQuery('autoLogoutCheck', MeInformationService.findMeInformation, {
    onError: (error: AxiosError<{ status: number }>) => {
      if (isLoggedIn && error?.response?.status === 403) {
        logout()
        toast.warning(
          'You have been automatically logged out as 30 days have passed since you logged in, please log in again',
          { duration: 60000 * 60 },
        )
      }
    },
    enabled: isLoggedIn && checkedAuthentication,
    refetchOnWindowFocus: true,
    refetchInterval: 30000,
  })

  return null
}

LogoutHandler.displayName = 'LogoutHandler'
